import * as React from 'react';
import JcsdAccountDetailsForm from 'components/Client/JcsdAccountDetailsForm';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class JcsdAccountDetailPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return <JcsdAccountDetailsForm />;
  }
}



